import React, { useRef, useEffect, useState as useReactState } from 'react';
import { useEnvironment } from '@wix/yoshi-flow-editor';
import s from './ProductImage.scss';
import cx from 'classnames';
import { DefaultImageIcon } from './DefaultImageIcon';
import {
  Image,
  ImageLoadingBehaviorOptions,
  ImageHoverEffectOptions,
  ImageResizeOptions,
} from '@wix/wix-ui-tpa/cssVars';
import { useControllerProps } from '../../ControllerContext';
import { useState } from '../../stores';
import {
  DEFAULT_IMAGE_WIDTH_DESKTOP,
  DEFAULT_IMAGE_WIDTH_MOBILE,
} from '../../../../../consts';
import { useStyles } from '@wix/tpa-settings/react';
import stylesParams from '../../../stylesParams';
import { convertRatioParamToRatioValue } from '../../../Settings/Tabs/DesignTab/utils';
import _ from 'lodash';

export enum ProductImageDataHook {
  image = 'ProductImageDataHook.image',
  defaultImage = 'ProductImageDataHook.defaultImage',
}
const ProductImage = () => {
  const styles = useStyles();
  const {
    state: { checkout },
  } = useState();
  const { isMobile } = useEnvironment();
  const { product, presetVariants } = useControllerProps().giftCardStore;
  const variantId = checkout.purchaseOptions.variantId;
  const selectedVariant = presetVariants.find(
    (variant) => variant.id === variantId,
  ) || (variantId !== 'custom' ? _.first(presetVariants) : undefined);
  const containerRef = useRef<HTMLDivElement>(null);

  const [mobileWidth, setMobileWidth] = useReactState(
    DEFAULT_IMAGE_WIDTH_MOBILE,
  );

  const imageMedia = selectedVariant?.media || product?.media;
  const imageRatioFromSettings = convertRatioParamToRatioValue(
    styles.get(stylesParams.imageRatio),
  );
  const aspectRatio = imageMedia && imageMedia.width / imageMedia.height;

  useEffect(() => {
    if (!isMobile) {
      return;
    }

    const updateMobileWidth = () => {
      if (containerRef.current) {
        const newWidth = containerRef.current.offsetWidth;
        if (newWidth > 0) {
          setMobileWidth(newWidth);
        }
      }
    };

    updateMobileWidth();
    window.addEventListener('resize', updateMobileWidth);

    return () => {
      window.removeEventListener('resize', updateMobileWidth);
    };
  }, [isMobile, setMobileWidth]);

  const DefaultImage = () => {
    return (
      <div
        data-hook={ProductImageDataHook.defaultImage}
        className={cx(
          s.defaultImage,
          s.imageContainer,
          isMobile && s.defaultImageMobile,
        )}
      >
        <DefaultImageIcon />
      </div>
    );
  };

  return product && imageMedia?.url ? (
    <div ref={containerRef} className={s.imageClip}>
      <Image
        data-hook={ProductImageDataHook.image}
        className={s.imageContainer}
        key={imageMedia.url}
        src={imageMedia.url}
        width={isMobile ? mobileWidth : DEFAULT_IMAGE_WIDTH_DESKTOP}
        alt={imageMedia.alt_image}
        resize={ImageResizeOptions.cover}
        aspectRatio={imageRatioFromSettings || aspectRatio}
        loadingBehavior={ImageLoadingBehaviorOptions.blur}
        hoverEffect={ImageHoverEffectOptions.zoom}
      />
    </div>
  ) : (
    <DefaultImage />
  );
};

export default ProductImage;
